export const ok_emoji = '✔'
export const error_emoji = '✖'
